export const colourTokens = {
    black: '#000000',
    surface1: '#f3f4f6',
    surface2: '#f9f9f9',
    surface3: '#fbfbfb',
    surface5: '#5768ff',
    surface6: '#1e1e1e',
    surface7: '#242424',
    surface8: '#2c2c2c',
    surface9: '#1e1e1e',
    white: '#ffffff',
    blue100: '#f4fbff',
    blue200: '#d2eeff',
    blue300: '#b7e3ff',
    blue400: '#9cd8ff',
    blue500: '#82ceff',
    blue600: '#58beff',
    blue700: '#0a9efc',
    blue800: '#0484d4',
    blue900: '#0067a8',
    brandAzureBlue: '#5768ff',
    brandAzureBlueAltDark: '#3d51ff',
    brandAzureBlueAlternate: '#7986ff',
    brandMidnightBlue: '#000623',
    brandMidnightBlueAlt: '#33384f',
    brandScienceBlue: '#3457ff',
    charcoal100: '#ebf1f9',
    charcoal200: '#e4edf9',
    charcoal300: '#d3e2f4',
    charcoal400: '#bdcfe4',
    charcoal500: '#90abcc',
    charcoal600: '#8fa4be',
    charcoal700: '#6e87a5',
    charcoal800: '#5b7493',
    charcoal900: '#4a5878',
    charcoal950: '#3e4b68',
    green100: '#ecf6f0',
    green150: '#e8f1ec',
    green200: '#d2f1de',
    green300: '#b6e7c8',
    green400: '#85e2a8',
    green500: '#67cb8c',
    green600: '#48c676',
    green700: '#21af55',
    green800: '#0e933f',
    green900: '#097a32',
    grey100: '#f3f4f6',
    grey1000: '#0b0b0b',
    grey150: '#edeff1',
    grey200: '#e5e7eb',
    grey25: '#fcfcfd',
    grey250: '#dde0e5',
    grey300: '#d2d6db',
    grey350: '#bfc6cf',
    grey400: '#b2b5ba',
    grey450: '#91959c',
    grey50: '#f9fafb',
    grey500: '#6f7275',
    grey550: '#65676a',
    grey600: '#585a5c',
    grey650: '#434446',
    grey700: '#353638',
    grey750: '#272829',
    grey800: '#1e1f20',
    grey850: '#1d1d1f',
    grey900: '#18191a',
    grey950: '#171718',
    opaqueBlack10: '#0000001a',
    opaqueBlack20: '#00000033',
    opaqueBlack30: '#0000004d',
    opaqueBlack40: '#00000066',
    opaqueBlack50: '#00000080',
    opaqueBlack60: '#00000099',
    opaqueBlack70: '#000000b2',
    opaqueBlack80: '#000000cc',
    opaqueBlack90: '#000000e5',
    opaqueBrand30: '#5768ff4d',
    opaqueBrand40: '#5768ff66',
    opaqueBrand50: '#5768ff80',
    opaqueWhite05: '#ffffff0d',
    opaqueWhite10: '#ffffff1a',
    opaqueWhite20: '#ffffff33',
    opaqueWhite30: '#ffffff4d',
    opaqueWhite40: '#ffffff66',
    opaqueWhite50: '#ffffff80',
    opaqueWhite60: '#ffffff99',
    opaqueWhite70: '#ffffffb2',
    opaqueWhite80: '#ffffffcc',
    opaqueWhite90: '#ffffffe5',
    orange100: '#fff3e9',
    orange200: '#ffe7d1',
    orange300: '#ffdab8',
    orange400: '#ffc592',
    orange500: '#ffb471',
    orange600: '#ff9a3f',
    orange700: '#fd7800',
    orange800: '#dd6a03',
    orange900: '#bd5b03',
    red200: '#fff0f0',
    red300: '#ffc3c3',
    red400: '#ff9494',
    red500: '#ff7c7c',
    red600: '#fd6464',
    red700: '#ec4949',
    red800: '#c72f2f',
    red900: '#881e1e',
    violet300: '#e6d7ff',
    violet500: '#d1bbf4',
    violet600: '#c2a3f5',
    violet700: '#ac79ff',
    violet800: '#8843f9',
    yellow300: '#fff2b8',
    yellow400: '#faeaa4',
    yellow500: '#f2df8b',
    yellow600: '#e8d47e',
    yellow700: '#f8cd10',
    yellow800: '#d2ac01',
    yellow900: '#977b01',
    transparent: '#ffffff00',
    backgroundBlack: '#000000',
    backgroundBrand: '#5768ff',
    backgroundPage: '#2c2c2c',
    backgroundPageAuthentication: '#000000',
    backgroundWarning: '#ec4949',
    backgroundWhite: '#ffffff',
    borderBlack: '#000000',
    borderBrand: '#5768ff',
    borderDisabled: '#353638',
    borderPrimary: '#585a5c',
    borderQuarterary: '#272829',
    borderSecondary: '#434446',
    borderTertiary: '#353638',
    borderWarning: '#ff7c7c',
    borderWhite: '#ffffff',
    foregroundBlack: '#000000',
    foregroundBrand: '#5768ff',
    foregroundWhite: '#ffffff',
    textBlack: '#000000',
    textDisabled: '#6f7275',
    textHighlight: '#ffb471',
    textPlaceholder: '#6f7275',
    textPrimary: '#ffffff',
    textQuarterary: '#6f7275',
    textSecondary: '#dde0e5',
    textSuccess: '#67cb8c',
    textTertiary: '#91959c',
    textWarning: '#ff7c7c',
    textWhite: '#ffffff',
    avatarActiveBg: '#353638',
    avatarActiveBorder: '#585a5c',
    avatarDefaultBg: '#e5e7eb',
    avatarDefaultBorder: '#ffffff',
    avatarDefaultFg: '#6f7275',
    avatarInvitedBg: '#ffffff00',
    avatarInvitedBorder: '#585a5c',
    avatarSuspendedBg: '#ffffff00',
    avatarSuspendedBorder: '#585a5c',
    btnCloseDefaultBg: '#ffffff00',
    btnCloseDefaultBorder: '#ffffff00',
    btnCloseDefaultText: '#dde0e5',
    btnCloseHoverBg: '#00000080',
    btnCloseHoverBorder: '#ffffff00',
    btnCloseHoverText: '#ffffff',
    btnDestructDefaultBg: '#ec4949',
    btnDestructDefaultBorder: '#ec4949',
    btnDestructDefaultText: '#ffffff',
    btnDestructDisabledBg: '#ffffff00',
    btnDestructDisabledBorder: '#585a5c',
    btnDestructDisabledText: '#6f7275',
    btnDestructFocussedBg: '#c72f2f',
    btnDestructFocussedBorder: '#881e1e',
    btnDestructFocussedText: '#ffffff',
    btnDestructHoverBg: '#c72f2f',
    btnDestructHoverBorder: '#c72f2f',
    btnDestructHoverText: '#ffffff',
    btnDestructProgressBg: '#ffffff00',
    btnDestructProgressBorder: '#ffffff00',
    btnDestructProgressText: '#ffffff',
    btnPrimaryDefaultBg: '#5768ff',
    btnPrimaryDefaultBorder: '#5768ff',
    btnPrimaryDefaultText: '#ffffff',
    btnPrimaryDisabledBg: '#585a5c',
    btnPrimaryDisabledBorder: '#585a5c',
    btnPrimaryDisabledText: '#91959c',
    btnPrimaryFocussedBg: '#3d51ff',
    btnPrimaryFocussedBorder: '#3d51ff',
    btnPrimaryFocussedText: '#ffffff',
    btnPrimaryHoverBg: '#3d51ff',
    btnPrimaryHoverBorder: '#3d51ff',
    btnPrimaryHoverText: '#ffffff',
    btnPrimaryProgressBg: '#ffffff00',
    btnPrimaryProgressBorder: '#ffffff00',
    btnPrimaryProgressText: '#ffffff',
    btnQuarteraryDefaultBg: '#ffffff00',
    btnQuarteraryDefaultBorder: '#ffffff00',
    btnQuarteraryDefaultText: '#7986ff',
    btnQuarteraryDisabledBg: '#ffffff00',
    btnQuarteraryDisabledBorder: '#ffffff00',
    btnQuarteraryDisabledText: '#6f7275',
    btnQuarteraryHoverBg: '#171718',
    btnQuarteraryHoverBorder: '#ffffff00',
    btnQuarteraryHoverText: '#5768ff',
    btnQuarteraryProgressBg: '#ffffff00',
    btnQuarteraryProgressBorder: '#ffffff00',
    btnQuarteraryProgressText: '#ffffff',
    btnSecondaryDefaultBg: '#585a5c',
    btnSecondaryDefaultBorder: '#585a5c',
    btnSecondaryDefaultText: '#ffffff',
    btnSecondaryDisabledBg: '#585a5c',
    btnSecondaryDisabledBorder: '#585a5c',
    btnSecondaryDisabledText: '#91959c',
    btnSecondaryFocussedBg: '#6f7275',
    btnSecondaryFocussedBorder: '#91959c',
    btnSecondaryFocussedText: '#ffffff',
    btnSecondaryHoverBg: '#6f7275',
    btnSecondaryHoverBorder: '#6f7275',
    btnSecondaryHoverText: '#ffffff',
    btnSecondaryProgressBg: '#ffffff00',
    btnSecondaryProgressBorder: '#ffffff00',
    btnSecondaryProgressText: '#ffffff',
    btnTertiaryDefaultBg: '#ffffff00',
    btnTertiaryDefaultBorder: '#bfc6cf',
    btnTertiaryDefaultText: '#e5e7eb',
    btnTertiaryDisabledBg: '#ffffff00',
    btnTertiaryDisabledBorder: '#585a5c',
    btnTertiaryDisabledText: '#6f7275',
    btnTertiaryFocussedBg: '#474747',
    btnTertiaryFocussedBorder: '#f3f4f6',
    btnTertiaryFocussedText: '#e5e7eb',
    btnTertiaryHoverBg: '#474747',
    btnTertiaryHoverBorder: '#f3f4f6',
    btnTertiaryHoverText: '#ffffff',
    btnTertiaryProgressBg: '#ffffff00',
    btnTertiaryProgressBorder: '#ffffff00',
    btnTertiaryProgressText: '#ffffff',
    btnTooltipDefaultBg: '#ffffff00',
    btnTooltipDefaultBorder: '#ffffff00',
    btnTooltipDefaultText: '#91959c',
    btnTooltipDisabledBg: '#ffffff00',
    btnTooltipDisabledBorder: '#ffffff00',
    btnTooltipDisabledText: '#6f7275',
    btnTooltipHoverBg: '#ffffff00',
    btnTooltipHoverBorder: '#ffffff00',
    btnTooltipHoverText: '#5768ff',
    checkboxActiveBg: '#5768ff',
    checkboxActiveBorder: '#b2b5ba',
    checkboxActiveFg: '#ffffff',
    checkboxDisabledBg: '#585a5c',
    checkboxDisabledBorder: '#6f7275',
    checkboxDisabledFg: '#6f7275',
    dialogBg: '#242424',
    dialogBorder: '#585a5c',
    dialogDiscardBg: '#7986ff',
    dialogDiscardBorder: '#ffffff00',
    dialogDiscardBtnPrimaryDefaultBg: '#dde0e5',
    dialogDiscardBtnPrimaryDefaultBorder: '#dde0e5',
    dialogDiscardBtnPrimaryDefaultText: '#5768ff',
    dialogDiscardBtnPrimaryFocussedBg: '#ffffff',
    dialogDiscardBtnPrimaryFocussedBorder: '#ffffff',
    dialogDiscardBtnPrimaryFocussedText: '#7986ff',
    dialogDiscardBtnPrimaryHoverBg: '#ffffff',
    dialogDiscardBtnPrimaryHoverBorder: '#ffffff',
    dialogDiscardBtnPrimaryHoverText: '#7986ff',
    dialogDiscardBtnSecondaryDefaultBg: '#ffffff00',
    dialogDiscardBtnSecondaryDefaultBorder: '#bfc6cf',
    dialogDiscardBtnSecondaryDefaultText: '#dde0e5',
    dialogDiscardBtnSecondaryFocussedBg: '#ffffff1a',
    dialogDiscardBtnSecondaryFocussedBorder: '#ffffff',
    dialogDiscardBtnSecondaryFocussedText: '#ffffff',
    dialogDiscardBtnSecondaryHoverBg: '#ffffff1a',
    dialogDiscardBtnSecondaryHoverBorder: '#ffffff',
    dialogDiscardBtnSecondaryHoverText: '#ffffff',
    dialogDiscardTextPrimary: '#ffffff',
    frmInputBorder: '#e5e7eb',
    frmInputDisabled: '#353638',
    frmInputError: '#ec4949',
    frmInputOutline: '#3457ff',
    frmInputTextSelection: '#4a5878',
    headerAdminBg: '#0000001a',
    headerAdminBorder: '#00000033',
    headerAdminText: '#e5e7eb',
    linkDefaultBg: '#ffffff00',
    linkDefaultText: '#58beff',
    linkDisabledBg: '#ffffff00',
    linkDisabledText: '#6f7275',
    linkHoverBg: '#ffffff00',
    linkHoverText: '#0484d4',
    linkNeutralBg: '#ffffff00',
    linkNeutralText: '#91959c',
    listListBg: '#1e1e1e',
    listRowBg: '#ffffff00',
    listRowBorder: '#ffffff00',
    listRowHoverBg: '#353638',
    listRowSelectedBg: '#3457ff',
    listRowSeparatorFg: '#353638',
    listSwatchBorder: '#00000033',
    listSwatchFill: '#0067a8',
    menuBg: '#1e1e1e',
    menuRowBg: '#ffffff00',
    menuRowHoverBg: '#5768ff',
    menuRowHoverDestructiveBg: '#ec4949',
    menuRowSelectedBg: '#5768ff',
    menuRowSeparatorBg: '#353638',
    menuTextDisabled: '#6f7275',
    menuTextPrimary: '#ffffff',
    menuTextWarning: '#ff7c7c',
    navSidebarBg: '#1e1e1e',
    navSidebarBorder: '#18191a',
    navSidebarChildActiveBg: '#ffffff1a',
    navSidebarChildBg: '#ffffff00',
    navSidebarChildBorder: '#ffffff33',
    navSidebarChildHoverBg: '#ffffff0d',
    navSidebarParentActiveBg: '#ffffff00',
    navSidebarParentBg: '#ffffff00',
    navSidebarParentBorder: '#5768ff',
    navSidebarParentHoverBg: '#434446',
    navSidebarTextPrimary: '#ffffff',
    navSidebarTextSecondary: '#dde0e5',
    navSidebarTextTertiary: '#91959c',
    navbarBg: '#1e1e1e',
    navbarBorder: '#434446',
    navbarMenuActiveText: '#ffffff',
    navbarMenuDefaultText: '#b2b5ba',
    navbarMenuHoverText: '#ffffff',
    navbarMenuUnderlineBg: '#5768ff',
    navbarPathDefaultText: '#ffffff',
    navbarPathHoverText: '#58beff',
    navbarProfileActiveBg: '#ffffff00',
    navbarProfileActiveText: '#91959c',
    navbarProfileDefaultText: '#b2b5ba',
    navbarProfileHoverBg: '#ffffff00',
    navbarProfileHoverText: '#7986ff',
    navbarShareDefaultText: '#d2d6db',
    navbarShareHoverText: '#58beff',
    notificationBg: '#000000cc',
    notificationBorder: '#ffffff',
    notificationBtnDefaultBg: '#000000cc',
    notificationBtnDefaultFg: '#b2b5ba',
    notificationBtnHoverBg: '#000000',
    notificationBtnHoverFg: '#ffffff',
    notificationSeparator: '#353638',
    notificationTextPrimary: '#ffffff',
    notificationTextSecondary: '#dde0e5',
    pillAccessEndBg: '#c2a3f5',
    pillAccessFg: '#8843f9',
    pillAccessStartBg: '#e6d7ff',
    pillPermissionEndBg: '#67cb8c',
    pillPermissionFg: '#097a32',
    pillPermissionStartBg: '#b6e7c8',
    pillTagEndBg: '#ffb471',
    pillTagFg: '#bd5b03',
    pillTagStartBg: '#ffdab8',
    pillUserEndBg: '#b2b5ba',
    pillUserFg: '#65676a',
    pillUserStartBg: '#f9fafb',
    poiBgDefault: '#000000b2',
    poiBgHover: '#000000',
    poiBorder: '#353638',
    poiTextPrimary: '#ffffff',
    poiTextQuarterary: '#6f7275',
    poiTextSecondary: '#dde0e5',
    poiTextTertiary: '#91959c',
    popupBg: '#1e1e1e',
    popupBorder: '#353638',
    popupFooterBg: '#2c2c2c',
    progressBar: '#7986ff',
    progressBarActiveFg0: '#7986ff',
    progressBarActiveFg100: '#7986ff',
    progressBarActiveGlow: '#5768ff',
    progressBarBg: '#585a5c',
    progressSpinnerFg: '#65676a',
    progressTextPrimary: '#ffffff',
    scrollbarBg: '#00000033',
    scrollbarBorder: '#353638',
    scrollbarHandle: '#6f7275',
    scrollbarHandleTransparent: '#ffffff33',
    sidebarCommonBg: '#000000b2',
    sidebarCommonBorder: '#ffffff00',
    sidebarCommonHeaderBg: '#00000066',
    sidebarCommonRowHoverBg: '#18191a',
    sidebarCommonRowHoverBorder: '#5768ff',
    sidebarCommonTreeArrows: '#ffffff',
    sidebarExploreBorder: '#0000004d',
    sidebarExploreChildBg: '#00000033',
    sidebarExploreFooterBg: '#00000033',
    sidebarExploreParentBg: '#00000033',
    sidebarSourceBorder: '#0000004d',
    sidebarSourceChildBg: '#00000033',
    sidebarSourceFooterBg: '#0000004d',
    sidebarSourceParentBg: '#00000033',
    sidebarTextPrimary: '#ffffff',
    sidebarTextSecondary: '#dde0e5',
    sidebarTextTertiary: '#91959c',
    sidebarModelsBorder: '#434446',
    sidebarModelsCollapsedBg: '#1d1d1f',
    sidebarModelsRootBg: '#2c2c2c',
    sidebarModelsTreeBg: '#2c2c2c',
    sidebarModelsBtnDefaultBg: '#ffffff00',
    sidebarModelsBtnDefaultFg: '#91959c',
    sidebarModelsBtnHoverBg: '#171718',
    sidebarModelsBtnHoverFg: '#7986ff',
    sidebarModelsSplitterDefaultFg: '#434446',
    sidebarModelsSplitterHoverFg: '#7986ff',
    sidebarBtnFilterActiveBg: '#ff9a3f',
    sidebarBtnFilterActiveText: '#ffffff',
    sidebarBtnFilterDefaultBg: '#ffffff00',
    sidebarBtnFilterDefaultText: '#91959c',
    sidebarBtnFilterDisabledBg: '#ffffff00',
    sidebarBtnFilterDisabledText: '#585a5c',
    sidebarBtnFilterHoverBg: '#000000',
    sidebarBtnFilterHoverText: '#ffffff',
    sidebarBtnPrimaryActiveBg: '#5768ff',
    sidebarBtnPrimaryActiveText: '#ffffff',
    sidebarBtnPrimaryDefaultBg: '#ffffff00',
    sidebarBtnPrimaryDefaultText: '#91959c',
    sidebarBtnPrimaryDisabledBg: '#ffffff00',
    sidebarBtnPrimaryDisabledText: '#6f7275',
    sidebarBtnPrimaryHoverBg: '#000000',
    sidebarBtnPrimaryHoverText: '#ffffff',
    sidebarBtnSecondaryActiveBg: '#000000',
    sidebarBtnSecondaryActiveText: '#5768ff',
    sidebarBtnSecondaryDefaultBg: '#ffffff00',
    sidebarBtnSecondaryDefaultText: '#91959c',
    sidebarBtnSecondaryDisabledBg: '#ffffff00',
    sidebarBtnSecondaryDisabledText: '#434446',
    sidebarBtnSecondaryHoverBg: '#000000',
    sidebarBtnSecondaryHoverText: '#ffffff',
    sidebarBtnSecondaryProgressBg: '#ffffff00',
    sidebarBtnSecondaryProgressText: '#ffffff',
    sidebarBtnStateDefaultBg: '#000000b2',
    sidebarBtnStateDefaultFg: '#d2d6db',
    sidebarBtnStateHoverBg: '#000000',
    sidebarBtnStateHoverFg: '#ffffff',
    sidebarCheckboxCheckedBg: '#5768ff',
    sidebarCheckboxCheckedBorder: '#5768ff',
    sidebarCheckboxCheckedFg: '#ffffff',
    sidebarCheckboxDisabledBg: '#585a5c',
    sidebarCheckboxDisabledBorder: '#585a5c',
    sidebarCheckboxDisabledFg: '#434446',
    sidebarCheckboxUncheckedBg: '#ffffff',
    sidebarCheckboxUncheckedBorder: '#ffffff',
    sidebarCheckboxUncheckedFg: '#ffffff',
    sliderBarBg: '#91959c',
    sliderHandleBg: '#ffffff',
    sliderHandleBorder: '#5768ff',
    snackbarBgInfo: '#0067a8',
    snackbarBgNeutral: '#fcfcfd',
    snackbarBgSuccess: '#0e933f',
    snackbarBgWarning: '#c72f2f',
    snackbarBorderSeparator: '#ffffff33',
    snackbarBtnActionDefaultBg: '#ffffff00',
    snackbarBtnActionDefaultFg: '#ffffff99',
    snackbarBtnActionHoverBg: '#0000004d',
    snackbarBtnActionHoverFg: '#e5e7eb',
    snackbarBtnCloseDefaultBg: '#ffffff00',
    snackbarBtnCloseDefaultFg: '#ffffff99',
    snackbarBtnCloseHoverBg: '#00000033',
    snackbarBtnCloseHoverFg: '#ffffff',
    snackbarTextMessage: '#ffffff',
    snackbarDeprecatedBannerInfo: '#82ceff',
    snackbarDeprecatedBannerNeutral: '#6f7275',
    snackbarDeprecatedBannerSuccess: '#67cb8c',
    snackbarDeprecatedBannerWarning: '#ff7c7c',
    snackbarDeprecatedBg: '#000000b2',
    snackbarDeprecatedBorderContainer: '#6f7275',
    snackbarDeprecatedBorderSeparator: '#353638',
    snackbarDeprecatedBtnActionDefaultBg: '#ffffff00',
    snackbarDeprecatedBtnActionDefaultFg: '#91959c',
    snackbarDeprecatedBtnActionHoverBg: '#000000',
    snackbarDeprecatedBtnActionHoverFg: '#0484d4',
    snackbarDeprecatedBtnCloseDefaultBg: '#ffffff00',
    snackbarDeprecatedBtnCloseDefaultFg: '#65676a',
    snackbarDeprecatedBtnCloseHoverBg: '#000000',
    snackbarDeprecatedBtnCloseHoverFg: '#ffffff',
    snackbarDeprecatedTextPrimary: '#ffffff',
    snackbarDeprecatedTextSecondary: '#dde0e5',
    statusActive: '#85e2a8',
    statusCancelled: '#b2b5ba',
    statusComplete: '#b2b5ba',
    statusDraft: '#d1bbf4',
    statusExpired: '#b2b5ba',
    statusGhosted: '#e5e7eb',
    statusInactive: '#ff7c7c',
    statusPublished: '#58beff',
    statusRetired: '#6f7275',
    statusTextPrimary: '#353638',
    statusTextQuart: '#b2b5ba',
    statusTextSecondary: '#585a5c',
    statusTextTertiary: '#6f7275',
    tabActiveBg: '#ffffff00',
    tabActiveBorder: '#7986ff',
    tabActiveText: '#ffffff',
    tabDisabledBg: '#ffffff00',
    tabDisabledBorder: '#ffffff00',
    tabDisabledText: '#6f7275',
    tabHorizontalLine: '#5768ff',
    tabHoverBg: '#ffffff00',
    tabHoverBorder: '#5768ff',
    tabHoverText: '#ffffff',
    tabInactiveBg: '#ffffff00',
    tabInactiveBorder: '#ffffff00',
    tabInactiveText: '#91959c',
    tabSeparatorBg: '#ffffff00',
    tabInlineActiveText: '#7986ff',
    tabInlineDisabledText: '#6f7275',
    tabInlineHoverText: '#ffffff',
    tabInlineInactiveText: '#91959c',
    tagDefaultBg: '#1e1f20',
    tagDefaultBorder: '#353638',
    tagHoverBg: '#585a5c',
    tagHoverBorder: '#585a5c',
    tagTextDisabled: '#6f7275',
    tagTextPrimary: '#ffffff',
    tagTextSecondary: '#dde0e5',
    tagTextTertiary: '#91959c',
    tblFooterBg: '#ffffff00',
    tblHeaderBg: '#2c2c2c',
    tblRowBg: '#ffffff00',
    tblRowBorder: '#434446',
    tblRowHoverBg: '#1e1f20',
    tblRowSelectedBg: '#4a5878',
    tblTableBg: '#2c2c2c',
    tblTextPrimary: '#ffffff',
    tblTextSecondary: '#dde0e5',
    tblTextSuccess: '#67cb8c',
    tblTextTertiary: '#91959c',
    toggleDisabledBg: '#585a5c',
    toggleDisabledHandleBg: '#6f7275',
    toggleDisabledHandleBorder: '#585a5c',
    toggleDisabledHandleFg: '#585a5c',
    toggleOffBg: '#b2b5ba',
    toggleOffHandleBg: '#ffffff',
    toggleOffHandleBorder: '#b2b5ba',
    toggleOnBg: '#5768ff',
    toggleOnHandleBg: '#ffffff',
    toggleOnHandleBorder: '#5768ff',
    toggleOnHandleFg: '#5768ff',
    toolbarActiveBg: '#5768ff',
    toolbarActiveFg: '#ffffff',
    toolbarDefaultBg: '#ffffff00',
    toolbarDefaultFg: '#e5e7eb',
    toolbarDisabledBg: '#ffffff00',
    toolbarDisabledFg: '#6f7275',
    toolbarHoverBg: '#000000',
    toolbarHoverFg: '#ffffff',
    toolbarTierOneBg: '#00000066',
    toolbarTierTwoBg: '#00000099',
    toolbarBtnStateDefaultClosedBg: '#000000b2',
    toolbarBtnStateDefaultFg: '#d2d6db',
    toolbarBtnStateDefaultOpenBg: '#ffffff00',
    toolbarBtnStateHoverBg: '#000000',
    toolbarBtnStateHoverFg: '#ffffff',
    tooltipsBg: '#1e1e1e',
    tooltipsBorder: '#353638',
    tooltipsPointerBg: '#353638',
    tooltipsTextPrimary: '#ffffff',
    tooltipsTextSecondary: '#91959c',
    treeBtnDefaultBg: '#ffffff00',
    treeBtnHoverBg: '#5768ff66',
    treeRowDefaultBg: '#ffffff00',
    treeRowDefaultBorder: '#ffffff00',
    treeRowHoverBorder: '#5768ff',
    treeRowSelectedBg: '#3e4b68',
    treeRowSelectedBorder: '#5768ff',
    wktCyan: '#31aefd',
    wktGreen: '#0ceb5e',
    wktGrey: '#d4d4d4',
    wktMagenta: '#fd5ab2',
    wktOrange: '#ee8f3a'
};
